import { useCurrentUser } from 'api/hooks/useCurrentUser';
import { SubscriptionTier } from 'api/models/Users';

export const useSubscriptionTier = (): SubscriptionTier => {
  const { data: user } = useCurrentUser();
  return user?.tenant?.subscriptionId ?? 't1';
};

export const useIsTierZero = () => useSubscriptionTier() == 't0';
